{
  "infoStocksDescription": {
    "title": "Описание",
    "error": "Не удалось получить информацию о компании",
    "ceo": "Гендиректор",
    "employees": "Работники",
    "website": "Веб-сайт",
    "headquarters": "Штаб-квартира",
    "exchange": "Биржа",
    "industry": "Отрасль",
    "sector": "Сектор",
    "founded": "Основана"
  }
}
